import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/lib/supabase'
import { useOnlineStatus } from './useOnlineStatus'

export function useMobileDocuments(userProfileId) {
  const isOnline = useOnlineStatus()
  const [documents, setDocuments] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchDocuments = useCallback(async () => {
    if (!userProfileId) return
    setLoading(true)

    if (isOnline) {
      try {
        const { data, error } = await supabase.rpc('app_get_user_documents_v2', {
          p_user_id: userProfileId,
        })
        if (error) throw error
        setDocuments(data || [])
      } catch (err) {
        console.error('[Documents] Error:', err)
      }
    }

    setLoading(false)
  }, [userProfileId, isOnline])

  useEffect(() => {
    fetchDocuments()
  }, [fetchDocuments])

  return { documents, loading, refetch: fetchDocuments }
}
